<div class="scale-widget" [class.readonly]="readonly">
  @for (option of options; track option) {
    <div class="d-flex flex-column align-items-center option" (click)="selectOption(option)">
      <div class="option-radio">
        @if (multiselect) {
          <mat-radio-group>
            <mat-radio-button
              color="primary"
              class="d-flex"
              [checked]="selectedOptionsHashes.indexOf(option.hash) !== -1"
              [value]="option.hash">
            </mat-radio-button>
          </mat-radio-group>
        } @else {
          <mat-radio-button
            class="d-flex"
            color="primary"
            [checked]="selectedOptionsHashes.indexOf(option.hash) !== -1"
            [value]="option.hash">
          </mat-radio-button>
        }
      </div>
      <span class="option-text" [autoTextDirection]="enableAutoTextDirection" [autoTextDirectionValue]="option.text">{{ option.text }}</span>
    </div>
  }
</div>
